<template>
  <div :class="classes">
    <pt-page-title title="投保信息详情"></pt-page-title>
    <pt-sub-title title="投保信息"></pt-sub-title>
     <table :class="$style['insure-info-table']">
       <pt-message-table-item label="提交时间">{{insureInfoDetail.created_date}}</pt-message-table-item>
       <pt-message-table-item label="合同编号">{{insureInfoDetail.contractCode}}</pt-message-table-item>
       <pt-message-table-item label="保险明细">
         <div :class="$style['specification-table-div']" class="page-background">
          <table :class="$style['specification-table']">
              <th>
                  <td>样本ID</td>
                  <td>保险产品名称</td>
                  <td>存储产品名称</td>
              </th>
              <tr v-for="(item,index) in insureInfoDetail.insurances" :key="index">
                  <td>{{item.proBarcode}}</td>
                  <td>{{item.type}}</td>
                  <td>{{item.productName}}</td>
              </tr>
          </table>
         </div>
       </pt-message-table-item>
       <pt-message-table-item label="监护人姓名">{{insureInfoDetail.guardianName}}</pt-message-table-item>
       <pt-message-table-item label="性别">{{insureInfoDetail.guardian_gender}}</pt-message-table-item>
       <pt-message-table-item label="身份证号">{{insureInfoDetail.guardianIdentityCard}}</pt-message-table-item>
       <pt-message-table-item label="被保人姓名">{{insureInfoDetail.insurerName}}</pt-message-table-item>
       <pt-message-table-item label="性别">{{insureInfoDetail.insurer_gender}}</pt-message-table-item>
       <pt-message-table-item label="身份证号">{{insureInfoDetail.insurerIdentityCard}}</pt-message-table-item>
       <pt-message-table-item label="户口本首页">
         <pt-img @click.native="onPreview($privateResourcesUrl + insureInfoDetail.householdRegisterHomePage)" :src="$privateResourcesUrl + insureInfoDetail.householdRegisterHomePage" :class="$style['images']"/>
       </pt-message-table-item>
       <pt-message-table-item label="户口本被保人页">
         <pt-img @click.native="onPreview($privateResourcesUrl + insureInfoDetail.householdRegisterInsurerPage)" :src="$privateResourcesUrl + insureInfoDetail.householdRegisterInsurerPage" :class="$style['images']"/>
       </pt-message-table-item>
       <pt-message-table-item v-for="(item,index) in insureInfoDetail.healthQas" :key="index" :label="item.label">
         {{item.answer.join('、')}}
       </pt-message-table-item>
       <pt-message-table-item label="移动端用户手机号">{{insureInfoDetail.userInformation && insureInfoDetail.userInformation.mobile}}</pt-message-table-item>
       <pt-message-table-item label="移动端用户名">{{insureInfoDetail.userInformation && insureInfoDetail.userInformation.firstName}}</pt-message-table-item>
     </table>
     <wt-image-preview v-if="previewVisible" @close-preview="closePreview" :value="images" :initial-index="currentIndex" :loop="false"></wt-image-preview>
     <div class="button-div">
      <el-button type="primary" v-if="hasUpdate" @click="update">编辑</el-button>
    </div>
  </div>
</template>

<script>
import { hasPermissions } from 'utils/permissions'

// 组件class前缀
const prefixCls = 'pt-insure-info-detail'
const PERM_INSURE_MATERIAL_MANAGEMENT = 'PERM_INSURE_MATERIAL_MANAGEMENT'

export default {
  name: 'pt-insure-info-detail',
  computed: {
    classes () {
      return `${prefixCls}`
    },
    hasUpdate () {
      return this.$auth.user() && this.$auth.user().permissions && hasPermissions(this.$auth.user().permissions, PERM_INSURE_MATERIAL_MANAGEMENT)
    }
  },
  props: {
    insureInfoDetail: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      previewVisible: false,
      images: '',
      currentIndex: 1
    }
  },
  methods: {
    closePreview () {
      this.previewVisible = false
    },
    onPreview (img) {
      this.images = img
      this.previewVisible = true
    },
    update () {
      this.$router.push(`/insure-info-form/${this.$route.params.id}`)
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.specification-table-div{
    margin-bottom: 20px;
    padding: 10px 20px 30px;
}
.specification-table{
    display: table!important;
    width: 100%;
    border-collapse:collapse!important;
    th,tr{
        width: 100%!important;
        max-width: 100%!important;
        display: table-row!important;
        padding: 0!important;
        list-style-type:none;
        justify-content:center!important;
        border-bottom: 1px solid #C6C9D3;
        color: #5B5B5B!important;
    }
    td{
        color: #5B5B5B!important;
        text-align: center;
        justify-content:flex-start!important;
        padding: 10px;
    }
}
.insure-info-table{
  padding: 0 20px;
}
.images{
  width: 200px;
}
</style>
